<template>
    <div class="container-view">
      <Breadcrumbs />
      <div class="row col-12 container-titles" style="display: flex">
        <div class="header-title col-10">Importar entidades</div>
        <div class="col-2" style="padding-top: 24px; align-items: flex-end">
          <q-btn
            data-cy="save-Entidad"
            style="width: 100%; margin-left: 0 !important"
            color="primary"
            label="Importar"
            icon="save"
            @click="importEntities"
          />
        </div>
      </div>
      <div class="row col-12 full-height">
        <div class="col-5 right-container">
            <q-card class="my-card">
                <q-card-section>
                    <q-form
                    ref="uploadForm"
                    class="q-gutter-md"
                        >
                        <q-file
                            filled
                            bottom-slots
                            v-model="dataFile"
                            accept=".csv"
                            :label="'Importar'"
                            :rules="[requiredFileVal]"
                            lazy-rules="ondemand"
                            counter>
                            <template v-slot:prepend>
                                <q-icon name="cloud_upload" @click.stop.prevent />
                            </template>
                            <template v-slot:append>
                                <q-icon name="close" @click.stop.prevent="dataFile = null" class="cursor-pointer" />
                            </template>
                        </q-file>
                    </q-form>
                </q-card-section>
            </q-card>
        </div>
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import { QForm, QFile, QIcon } from 'quasar';
import Message from '@/components/shared/mixins/Message.js';
import Loading from '@/components/shared/mixins/Loading.js';

export default {
  computed: {
    ...mapGetters({
      isSuperAdmin: 'PF/isSuperAdmin'
    })
  },
  components: { Breadcrumbs, QForm, QFile, QIcon },
  mixins: [Loading, Message],
  data: function () {
    return {
      dataFile: null
    };
  },
  methods: {
    async importEntities () {
      const isValid = await this.$refs.uploadForm.validate();
      let responseData = null;

      if (isValid) {
        let dataArray = {
          File: this.dataFile
        };

        const request = {
          controller: '/Entidad/ImportByFile',
          filter: {},
          contentType: 'multipart/form-data',
          body: dataArray
        };

        this.showLoading();
        await this.$store
          .dispatch('PF/postFile', request)
          .then(response => {
            responseData = {
              data: response.data,
              status: true
            };
            this.showMessage(`Se han importado ${response.data.processed} entidades con éxito`, 3000);
          })
          .catch(err => {
            this.showError(err.message);

            responseData = {
              data: null,
              status: false
            };
          })
          .finally(() => {
            this.hideLoading();
          });
      }

      return responseData;
    },
    // Validations of input
    requiredFileVal (files) {
      // At least one file is required
      return files || 'El fichero es obligatorio';
    }
  }
};
</script>
